var _defs, _rect, _rect2, _rect3, _rect4, _polygon, _polygon2, _polygon3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoKive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.55 58.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#211e1f;}.cls-2{fill:none;stroke:#211e1f;stroke-miterlimit:10;stroke-width:.84px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.89,
    y: 4.28,
    width: 12.52,
    height: 51.13
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 53.99,
    y: 4.28,
    width: 12.52,
    height: 51.13
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.87,
    y: 4.28,
    width: 12.52,
    height: 51.13
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 127.95,
    y: 4.28,
    width: 12.52,
    height: 51.13
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "34.64 4.28 48.83 4.28 30.73 28.93 17.01 28.93 34.64 4.28"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "110.05 4.28 126.96 4.28 89.18 55.42 89.18 33.21 110.05 4.28"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "31.2 30.77 17.01 30.77 35.11 55.42 48.83 55.42 31.2 30.77"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "175.06 1.2 167.31 10.45 181.83 28.93 195.55 28.93 175.06 1.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "181.36 30.77 195.55 30.77 175.06 57.26 166.71 48.64 181.36 30.77"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 142.26,
    y: 4.28,
    width: 19.68,
    height: 11.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 142.26,
    y: 24,
    width: 11.93,
    height: 11.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 142.26,
    y: 44.33,
    width: 19.68,
    height: 11.09
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKive);
export default __webpack_public_path__ + "static/media/logo-kive.cd6075a40b5ec46cd2f4105e2fddf829.svg";
export { ForwardRef as ReactComponent };